import { AbstractModel } from './abstract-model';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RideMetadataFieldOption extends AbstractModel {
  @autoserialize
  rideMetadataFieldId: number;

  @autoserialize
  value: string;

  @autoserialize
  active: boolean;
}
